<template>
  <div class="flex rounded-md border p-6">
    <ProductImage :product-media="productMedia" class="mr-4 h-28 w-20 rounded-md" />
    <div class="flex flex-1 flex-col gap-y-2 lg:gap-y-4">
      <div class="flex items-center">
        <p class="text-2xl font-medium">{{ productLabel }}</p>
        <MenuSelectField
          ref="registeredProductActionSelectField"
          v-model="selectedMenuOption"
          :options="menuOptions"
          class="ml-auto"
        />
      </div>
      <hr class="hidden lg:block" />
      <div class="grid grid-cols-1 gap-y-2 lg:grid-cols-3 lg:gap-y-4">
        <p class="flex flex-col lg:gap-y-1">
          <CommonLabel path="BWF/shop/account/products/registerDateLabel" class="font-medium" />
          <FormattedDate :date="product.registrationDate" pattern="DD.MM.YYYY" />
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CommonLabel from "~/templates/components/CommonLabel.vue";
import MenuSelectField from "~/templates/elements/form/MenuSelectField.vue";
import ProductImage from "~/templates/elements/ProductImage.vue";
import FormattedDate from "~/templates/elements/FormattedDate.vue";

const emit = defineEmits(["product-spare-parts", "remove-product"]);
const props = defineProps(["product"]);

const { getLabels } = useCommonLabels();
const commonLabels = getLabels("BWF/shop/account/products/", [
  "sparePartsActionLabel",
  "removeProductActionLabel",
]);

const menuOptions = computed(() => {
  return [
    {
      label: commonLabels.sparePartsActionLabel,
      value: "spareParts",
    },
    {
      label: commonLabels.removeProductActionLabel,
      value: "removeProduct",
    },
  ];
});

const registeredProductActionSelectField = ref(null);
const selectedMenuOption = ref("");

watch(selectedMenuOption, (options) => {
  switch (options) {
    case "spareParts":
      emit("product-spare-parts");
      break;
    case "removeProduct":
      emit("remove-product");
      break;
  }
  registeredProductActionSelectField.value?.reset();
});

const productMedia = computed(() => {
  return props.product?.cover?.media;
});

const productLabel = computed(() => {
  return props.product?.translated?.name;
});
</script>
